export default __webpack_public_path__ + "static/media/bunnycorner2.d0519d8f.png";